import React from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';

export class Widget extends React.Component {

    render() {
        const {
            icon,
            title,
            value,
            boxClass,
            onFilter,
        } = this.props;

        const classes = `info-box hover-expand-effect ${boxClass}`;

        return (
            <div>
                <div className={classes} onClick={onFilter}>
                    <div className="icon">
                        <i className="material-icons">{icon}</i>
                    </div>
                    <div className="content">
                        <div className="text">{title}</div>
                        <CountUp
                            className="number"
                            start={0}
                            end={value}
                            duration={1}
                            useEasing={true}
                            useGrouping={true}
                            decimals={0}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Widget.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.number,
    boxClass: PropTypes.string.isRequired,
    onFilter: PropTypes.func,
};

Widget.defaultProps = {
    value: 0,
};



// WEBPACK FOOTER //
// ./src/app/dashboard/widgets/Widget.jsx